import sportIds from '@/services/helpers/sports';

const { BASEBALL_ID, FOOTBALL_ID } = sportIds;

export const INFER_MODAL_SPORT_CONFIG = {
  [BASEBALL_ID]: {
    playerTypeTabs: [
      { key: 'pitchers', label: 'Pitchers', filter: { isPitcher: true } },
      { key: 'hitters', label: 'Hitters', filter: { isHitter: true } },
    ],
  },
  [FOOTBALL_ID]: {
    playerTypeTabs: [
      { key: 'quarterbacks', label: 'Quarterbacks', filter: { isQuarterback: true } },
      { key: 'non-quarterbacks', label: 'Non-Quarterbacks', filter: { isOffensiveNonQB: true } },
      { key: 'kickers', label: 'Kickers', filter: { isKicker: true } },
      { key: 'defensive', label: 'Defensive', filter: { isDefensive: true } },
    ],
  },
};

export const getInferModalSportConfig = (sportId) => INFER_MODAL_SPORT_CONFIG[sportId] || null;
